import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent.js';
import { menuStyle } from '../styles/Menu.styles.js';

export default InjectedStyledComponent(
	'p',
	'menu',
	['menuDescription'],
	undefined,
	undefined,
	undefined,
	menuStyle,
);
